// src/components/5.js
import React from 'react';

const Componente5 = () => {
  return (
    <div className="component-container">
      <h2>Número de Propósito: 5</h2>
      <p>
        Para una persona nacida el día 5, el número de propósito asociado sería 5.
      </p>
      <p>
        En numerología, el número 5 está relacionado con la libertad, la aventura y la versatilidad. El propósito de una persona nacida en el quinto día del mes puede incluir:
      </p>
      <ul>
        <li><strong>Buscar la Libertad Personal:</strong> La persona tiene un propósito relacionado con explorar y experimentar la vida sin restricciones. Buscan independencia y libertad para seguir sus propios caminos.</li>
        <li><strong>Explorar Nuevas Aventuras:</strong> El número 5 está asociado con la aventura y el cambio. Estas personas tienen el propósito de explorar nuevos horizontes y vivir experiencias emocionantes y variadas.</li>
        <li><strong>Adaptabilidad y Versatilidad:</strong> El propósito incluye ser capaz de adaptarse a diferentes situaciones y circunstancias, lo que les permite vivir una vida llena de cambios y desafíos.</li>
        <li><strong>Comunicarse y Conectar con los Demás:</strong> El número 5 está asociado con la comunicación, por lo que estas personas tienen el propósito de compartir sus experiencias y conocimientos con los demás de una manera atractiva y persuasiva.</li>
        <li><strong>Expandir sus Horizontes:</strong> Las personas con este número suelen tener el propósito de ampliar sus conocimientos y perspectivas, explorando nuevas ideas, culturas y formas de vida.</li>
      </ul>

      <h3>Características del Día de Nacimiento: 5</h3>
      <ul>
        <li><strong>Espíritu Libre:</strong> Las personas nacidas el día 5 son de espíritu libre y detestan sentirse atadas o restringidas. Les gusta moverse y cambiar constantemente.</li>
        <li><strong>Aventureras:</strong> Aman la aventura y disfrutan de los cambios y las experiencias emocionantes. No temen tomar riesgos para descubrir nuevas oportunidades.</li>
        <li><strong>Versatilidad:</strong> Estas personas son muy adaptables y versátiles. Pueden enfrentarse a diversas situaciones y encontrar la manera de salir adelante en cada una de ellas.</li>
        <li><strong>Comunicadoras:</strong> Son comunicadores naturales. Les gusta socializar y compartir sus ideas y experiencias con los demás.</li>
        <li><strong>Curiosidad:</strong> Tienen una mente curiosa y siempre están buscando aprender más, explorar diferentes temas y descubrir cosas nuevas.</li>
      </ul>

      <h4>Desafíos</h4>
      <ul>
        <li><strong>Falta de Compromiso:</strong> Pueden tener dificultades para comprometerse con personas o proyectos debido a su necesidad constante de cambio y aventura.</li>
        <li><strong>Impulsividad:</strong> Su amor por la libertad y la aventura puede hacer que tomen decisiones impulsivas sin pensar en las consecuencias a largo plazo.</li>
        <li><strong>Inquietud:</strong> Pueden sentirse inquietos o insatisfechos si no tienen suficiente estimulación o variedad en sus vidas.</li>
      </ul>

      <h4>Resumen</h4>
      <p>
        Las personas nacidas el día 5 son aventureras, versátiles y comunicativas. Su propósito en la vida está relacionado con la búsqueda de la libertad, la exploración de nuevas experiencias y la expansión de sus horizontes. Les encanta moverse, probar cosas nuevas y compartir sus conocimientos con los demás. Sin embargo, deben tener cuidado con la falta de compromiso y la impulsividad, y encontrar un equilibrio entre su amor por la aventura y la necesidad de estabilidad en algunos aspectos de su vida.
      </p>
    </div>
  );
};

export default Componente5;
